/** The plain chevron of a row that opens something, as the app draws it; decorative, so hidden from screen readers. */
export function RowChevron({ className, size = 18 }: { className: string; size?: number }) {
  return (
    <svg className={className} viewBox="0 0 20 20" width={size} height={size} aria-hidden="true" focusable="false">
      <path fill="currentColor" d="m7.6 15.4-1.2-1.2 4.2-4.2-4.2-4.2 1.2-1.2 5.4 5.4z" />
    </svg>
  );
}
